import { callApiToServer } from "../callApi";

export async function assignCourseToUser(authtoken, userId, courseId) {
  try {
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    const body = JSON.stringify({ user_id: userId, course_id: courseId });
    const endUrl = "v1/auth/admin/assign-course-to-user";

    const responseData = await callApiToServer(body, header, "POST", endUrl);
    return responseData;
  } catch (err) {
    throw err;
  }
}
